export default "__VITE_ASSET__DjLJhrx8__"